import { z } from "zod";
/** Availability describes installed platform adapters; it never grants source access. */
export const workflowDocumentAdapterDescriptorSchema = z.object({
    key: z.string(), available: z.boolean(), reason: z.string(),
    requiredSourceFields: z.array(z.string()),
}).strict();
export const WORKFLOW_DOCUMENT_ADAPTERS = [
    { key: "gmail_attachment", available: true,
        reason: "Requires a fresh authorized Gmail message projection and the owner's read credentials. Activation reviews the destination upload source.",
        requiredSourceFields: ["source_native_id", "source_revision_seq", "raw", "deleted"] },
    { key: "apron", available: false,
        reason: "No live Apron read adapter is installed. A validated read source must supply stable document identity, revision, bytes and deletion state before this adapter can be enabled.",
        requiredSourceFields: ["document_id", "source_revision", "document_bytes", "deleted"] },
];
